import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import SidebarWrapperTwoLevels from 'chameleon-src/components/SidebarWrapperTwoLevels';
import FauxdalNav from 'chameleon/src/components/FauxdalNav';
import MainNavTwoLevels from '../../basic/main-nav-two-levels';
import DigitalAssessmentInfoModalWrapper from 'chameleon-src/DigitalAssessmentInfoModalWrapper';
// Since drag and drop for `Resources & Assignments` require that both, the draggable
// and dropable elements share the same context, it has to be declared in a higher
// component which is common for sidebar labels and assessment rows
import LabelsDnDContext from 'chameleon/ui-stack/ui/assessments/labels-dnd/context';
// For future DnD functionalty one can nest `DndContext` and they should work as expected
// https://docs.dndkit.com/api-documentation/context-provider#nesting

const Container = (props) => {
  const { children, topNav, router, routes } = props;
  const currentRoute = routes[routes.length - 1];
  const { leftNav = true } = currentRoute;
  const xLabel =
    currentRoute.name && currentRoute.name.includes('results')
      ? ' results'
      : ' overview';
  return (
    <LabelsDnDContext>
      <div className="flex h-full">
        <div className="flex-initial">
          {leftNav && (
            <>
              <MainNavTwoLevels />
              <SidebarWrapperTwoLevels router={router} />
              <DigitalAssessmentInfoModalWrapper />{' '}
              {/* I am putting this here because this is supposed to be displayed in whatever the initial page for the user is */}
            </>
          )}
        </div>
        <main
          id="main-content"
          className={cn(
            'w-containerWidth flex-auto mobile:mt-25',
            leftNav && 'desktop:ml-98',
          )}
        >
          {(topNav && (
            <Fragment>
              {!leftNav && (
                <FauxdalNav router={router} closeAriaLabel={`Close${xLabel}`} />
              )}
              <div className="flex h-25 items-center px-8.4">{topNav}</div>
            </Fragment>
          )) ||
            null}
          {React.cloneElement(children, { route: currentRoute })}
        </main>
      </div>
    </LabelsDnDContext>
  );
};

Container.propTypes = {
  topNav: PropTypes.any,
};

Container.defaultProps = {
  topNav: null,
};

export default Container;
